import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RootLayout } from './RootLayout';
import LandingPage from '../landing/LandingPage';
import AuthPage from '../landing/AuthPage';
import ResetPasswordPage from '../landing/ResetPasswordPage';
import { LoadingScreen } from '../loadingscreen';
import { App3DLoader } from '../features/scene-3d/components/utils/App3DLoader';
import { AppLoadingProvider } from '../providers/AppLoadingProvider';
import DashboardPage from '../pages/Dashboard/DashboardPage';
import { RequireAuth } from '../shared/auth/RequireAuth';
import PrivacyPage from '../landing/PrivacyPage';
import TermsPage from '../landing/TermsPage';

const AdminPage = lazy(() => import('../pages/AdminPage/AdminPage'));

const App3D = lazy(() => import('../App3D'));

/** Маршруты приложения (React Router data API). */
export const appRouter = createBrowserRouter([
    {
        element: <RootLayout />,
        children: [
            { path: '/', element: <LandingPage /> },
            { path: '/auth', element: <AuthPage /> },
            { path: '/login', element: <Navigate to="/auth" replace /> },
            { path: '/register', element: <Navigate to="/auth" replace /> },
            { path: '/reset-password', element: <ResetPasswordPage /> },
            { path: '/privacy', element: <PrivacyPage /> },
            { path: '/terms', element: <TermsPage /> },
            {
                path: '/admin',
                element: (
                    <Suspense fallback={<LoadingScreen />}>
                        <AdminPage />
                    </Suspense>
                ),
            },
            {
                path: '/dashboard',
                element: (
                    <RequireAuth>
                        <DashboardPage />
                    </RequireAuth>
                ),
            },
            {
                path: '/app',
                element: (
                    <RequireAuth>
                        <AppLoadingProvider>
                            <Suspense fallback={<LoadingScreen />}>
                                <App3DLoader>
                                    <App3D />
                                </App3DLoader>
                            </Suspense>
                        </AppLoadingProvider>
                    </RequireAuth>
                ),
            },
            { path: '*', element: <Navigate to="/" replace /> },
        ],
    },
]);
